import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { mutate } from 'swr';
import { isDesktopUser, shouldForceClick } from '../../../Utils/ProductUtils';
import { createRippleEffectRelative } from '../../../Utils/helper';
import {
  checkVarient,
  fireProductActionEvent,
  getCartButton,
  goToCartForCategoryPage,
  productActionClick,
} from '../../../Utils/productAction';
import { useGetCartData } from '../../../datafetchers/CartWidget';
import { CssLoader } from '../../StoreHomePage/AddToCartButton/styled';
import {
  MobileStyle,
  NewAddToCartButton,
  OfferStrip,
  OutofStock,
  PdpButton,
  PdpButtonNew,
} from './styled';
import {
  maternityBraSkuList,
  maternityDresses,
  maternitySkusList,
} from '../OfferCarousel/constant';
import Cookies from 'js-cookie';

export default function MobileButtons(props) {
  const {
    productData,
    setAddedToCart,
    showcheckoutStrip,
    showBuyNow,
    fromSizePopup,
    showSizePopup,
    showanimation,
    sizePopupButtons,
    closeModalPopup,
    showNewDiaperVariantUx,
    openChooseVariantPopup,
    userType,
    showPrepaidXOff,
  } = props;
  const { data } = useGetCartData();
  const [cartButton, setCartButton] = useState(getCartButton(productData?.id));
  const router = useRouter();
  const [loaderState, setLoaderState] = useState('');
  const [loaderGoToCart, setLoaderGoToCart] = useState('');
  const [currentOfferIndex, setCurrentOfferIndex] = useState(0);
  const [variantsCount, setVariantsCount] = useState(0);
  const pdpActionButton = useRef();
  const mobileButtonRef = useRef();

  const showNewAddToCartButton = true;

  useEffect(() => {
    setCartButton(getCartButton(productData?.id));
    setLoaderState('');
  }, [router.query]);
  useEffect(() => {
    // Mobile User and  key Exist in param
    if (!isDesktopUser() && shouldForceClick()) {
      setTimeout(() => {
        pdpActionButton.current.click();
      }, [2000]);
    }
  }, []);

  const addGoToCart = async () => {
    fireProductActionEvent('clicked_add_to_cart', productData);
    if (cartButton == 1) {
      if (checkVarient()) {
        if (fromSizePopup == undefined) {
          showSizePopup(true);
          return true;
        } else {
          showanimation(true);
          return true;
        }
      }
      setLoaderState('loading');
      //1:"ADD TO CART",2:"GO TO CART"
      if (data) {
        await mutate('/api/getNewCartAmountOfUserWeb', null, false);
      }
      const apiResponse = await productActionClick(
        'cart',
        productData,
        cartButton,
        showSizePopup,
      );
      if (apiResponse == true) {
        setAddedToCart(true);
        setLoaderGoToCart('');
        setTimeout(() => {
          setCartButton(2); //1:"ADD TO CART",2:"GO TO CART"
        }, 800);
        setLoaderState('loaded');
      } else {
        setLoaderState('');
        setCartButton(1);
      }
    } else {
      setLoaderGoToCart('loading');
      const apiResponse = await goToCartForCategoryPage(
        productData,
        fromSizePopup,
        closeModalPopup,
      );
      if (apiResponse == true) {
        setLoaderState('');
        setLoaderGoToCart('loaded');
        setTimeout(() => {
          setLoaderGoToCart('');
        }, 800);
      } else {
        setLoaderState('');
      }
    }
  };

  const showLoadingScreen = (loaderState, isExp) => {
    return (
      <CssLoader
        className={loaderState === 'loaded' ? 'load-complete' : ''}
        theme="#fff"
        aplusplus={isExp}
      >
        <div
          className="checkmark draw"
          style={loaderState === 'loaded' ? { display: 'block' } : {}}
        ></div>
      </CssLoader>
    );
  };

  useEffect(() => {
    if (currentOfferIndex >= productData?.offers?.length) {
      setCurrentOfferIndex(0);
      return;
    }
    if (productData?.offers && productData?.offers.length > 0) {
      const timer = setInterval(() => {
        setCurrentOfferIndex((prevIndex) =>
          prevIndex >= productData?.offers.length - 1 ? 0 : prevIndex + 1,
        );
      }, 3000);
      return () => clearInterval(timer);
    }
  }, [productData?.offers?.length]);

  useEffect(() => {
    const count = parseInt(Cookies.get('variantSize') - 1) || 0;
    setVariantsCount(count);
  }, [Cookies.get('variantSize')]);

  return (
    <>
      <MobileStyle>
        {productData?.status === '4' &&
        (!productData.isFashionFirst || !checkVarient()) ? (
          <>
            <OutofStock fromSizePopup={fromSizePopup}>OUT OF STOCK</OutofStock>
          </>
        ) : (
          <>
            {showBuyNow || showBuyNow == undefined ? (
              <PdpButton
                className="buynowpdpbutton"
                white
                ref={mobileButtonRef}
                id="buynowbutton"
                onClick={(event) => {
                  createRippleEffectRelative(event, mobileButtonRef.current);
                  productActionClick('buyNow', productData, '', showSizePopup);
                }}
              >
                BUY NOW
              </PdpButton>
            ) : null}

            {showNewAddToCartButton && !fromSizePopup ? (
              <PdpButtonNew>
                <PdpButton
                  white={false}
                  showNewDiaperVariantUx={showNewDiaperVariantUx}
                  onClick={() => {
                    null;
                  }}
                  desktop={fromSizePopup}
                  ref={pdpActionButton}
                  // fromSizePopup={fromSizePopup}
                  sizePopupButtons={sizePopupButtons}
                  showNewAddToCartButton={showNewAddToCartButton}
                >
                  {showPrepaidXOff ? (
                    <OfferStrip offers={1}>
                      <span className="offer-transition" key={0}>
                        Extra 5% Off on online payments
                      </span>
                    </OfferStrip>
                  ) : productData?.offers && productData?.offers.length > 0 ? (
                    <OfferStrip offers={productData?.offers?.length || 0}>
                      <span
                        className="offer-transition"
                        key={currentOfferIndex}
                      >
                        {productData?.offers[currentOfferIndex]?.description +
                          ' Use code : '}
                        <strong>
                          {productData?.offers[currentOfferIndex]?.code}
                        </strong>
                      </span>
                    </OfferStrip>
                  ) : showPrepaidXOff ? (
                    <OfferStrip offers={1}>
                      <span className="offer-transition" key={0}>
                        Extra 5% Off on online payments
                      </span>
                    </OfferStrip>
                  ) : null}
                  <NewAddToCartButton>
                    {false &&
                    variantsCount > 0 &&
                    !maternityDresses.includes(productData?.id) ? (
                      <div className="savings" onClick={openChooseVariantPopup}>
                        <p className="beforeAndAfterPrices">
                          <span>{'₹' + productData?.price}</span>
                          {productData?.strikeprice ==
                          productData?.price ? null : (
                            <>
                              <span className="strikeprice">
                                {'₹' + productData?.strikeprice}
                              </span>
                            </>
                          )}
                        </p>
                        <div className="priceFlex">
                          {productData?.discountPercent ? (
                            <span className="discount">
                              {productData?.discountPercent + '% OFF'}
                            </span>
                          ) : null}
                          <p className="moreVarients">
                            {variantsCount} more variants {'>'}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="savings">
                        <p className="beforeAndAfterPrices">
                          <span>{'₹' + productData?.price}</span>
                          {productData?.strikeprice ==
                          productData?.price ? null : (
                            <>
                              <span className="strikeprice">
                                {'₹' + productData?.strikeprice}
                              </span>
                              <span className="discount">
                                {productData?.discountPercent + '% OFF'}
                              </span>
                            </>
                          )}
                        </p>
                        <div className="priceFlex">
                          <p className="inclTaxes">
                            (addl. taxes & charges applicable)
                          </p>
                        </div>
                      </div>
                    )}

                    <button
                      onClick={() => addGoToCart()}
                      suppressHydrationWarning={true}
                    >
                      {cartButton == 1
                        ? loaderState === 'loading' || loaderState === 'loaded'
                          ? showLoadingScreen(loaderState)
                          : 'ADD TO CART'
                        : loaderGoToCart === 'loading' ||
                            loaderGoToCart === 'loaded'
                          ? showLoadingScreen(loaderGoToCart)
                          : 'GO TO CART'}
                      <span></span>
                    </button>
                  </NewAddToCartButton>
                  <span></span>
                </PdpButton>
              </PdpButtonNew>
            ) : (
              <PdpButton
                onClick={() => addGoToCart()}
                desktop={fromSizePopup}
                ref={pdpActionButton}
                // fromSizePopup={fromSizePopup}
                sizePopupButtons={sizePopupButtons}
                suppressHydrationWarning={true}
              >
                {cartButton == 1
                  ? loaderState === 'loading' || loaderState === 'loaded'
                    ? showLoadingScreen(loaderState)
                    : 'ADD TO CART'
                  : loaderGoToCart === 'loading' || loaderGoToCart === 'loaded'
                    ? showLoadingScreen(loaderGoToCart)
                    : 'GO TO CART'}

                {/* <span></span> */}
              </PdpButton>
            )}
            {/* {showcheckoutStrip || showcheckoutStrip == undefined ? (
                            <CheckOutOfferStrip>
                                <SVGPDP
                                    id="greendiscount"
                                    width="16"
                                    height="16"
                                />

                                <p>Offers available on checkout</p>
                            </CheckOutOfferStrip>
                        ) : null} */}
          </>
        )}
      </MobileStyle>
    </>
  );
}
